<template>
  <DataListStateful
    title="Контактные лица"
    resource="contact-persons"
    store="contactPersons"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Имя", name: "name", sortable: true },
        { title: "Фамилия", name: "surname", sortable: true },
        {
          title: "Учетка по клиентам",
          name: "cabinetClients",
          sortable: false,
        },
        {
          title: "Телефон",
          name: "phones",
          type: "text-array-phone",
          sortable: true,
        },
        {
          title: "Логин",
          name: "cabinetLogins",
          sortable: false,
        },
        {
          title: "Email",
          name: "emails",
          type: "text-array",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Skype",
          name: "skypes",
          type: "text-array",
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Роль",
          name: "role",
          dataPath: "Role.Title",
          sortable: true,
          maxLength: 10,
        },
      ],
      filter: {
        name: {
          title: "Имя",
          type: "text",
        },
        surname: {
          title: "Фамилия",
          type: "text",
        },
        hasCabinetUser: {
          title: "Пользователи Кабинета Клиента",
          type: "bool",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
        skype: {
          title: "Skype",
          type: "text",
        },
        roles: {
          title: "Роль",
          type: "enum",
          resource: "contact-person-roles",
        },
      },
    };
  },
};
</script>
